import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-indicator',
    imports: [
        MatIconModule,
        CommonModule
    ],
    templateUrl: './indicator.component.html',
    styleUrls: ['./indicator.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IndicatorComponent {
  @Input() color: 'primary' | 'secondary' | 'warn' | 'danger' | 'info' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
}